export default __webpack_public_path__ + "static/media/group_collab.be173b6b.png";